import React from 'react';

export default function HelpCenterSearchPage() {
	return (
		<div className="h-550 w-1/2">
			{/* 
     */}
			<div className="SearchBar relative">
				<input
					className="border my-4 pl-5 py-3 rounded-3xl w-96 bg-gray-100 text-gray-800"
					type="text"
					placeholder="Search how-tos and more"
				/>
			</div>
			<div className="my-6">
				<h2 className="text-3xl font-medium ">Search results</h2>
				<span className="text-lg text-gray-500">8 matches</span>
			</div>
			<div>
				<div className="border border-l-0 border-r-0 border-t-0">
					<span className="text-sm text-gray-500 mb-1 block">How-to</span>
					<h3 className="underline font-semibold">
						Update your property revenue
					</h3>
					<span className="block pt-1 pb-10">
						It happens—revenue changes! If a guest needs to cancel their
						reservation, we’re here to help you with a quick rebound.
					</span>
				</div>
			</div>
		</div>
	);
}
